import React, { Component } from "react";
import KinderWhite from "../assets/KinderWhite.svg";
import { Link } from "react-router-dom";

import HamburgerMenu from "react-hamburger-menu";
import "./MobileHeader.css";

class MobileHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      color: this.props.color,
      backgroundColor: this.props.backgroundColor
    };
  }

  handleClick() {
    console.log(`click handled`);
    this.setState({
      open: !this.state.open
    });
  }

  render() {
    let { color, backgroundColor } = this.state;
    if (!color) {
      color = "#5C626C";
    }
    if (!backgroundColor) {
      backgroundColor = "transparent";
    }

    return (
      <div
        className="header-row"
        style={{
          backgroundColor: backgroundColor,
          display: "flex",
          justifyContent: "flex-end",
          flexWrap: "wrap",
          width: "100%",
          fontFamily: "Raleway",
          borderBottom: "none !important",
          paddingBottom: "5%"
        }}
      >
        <div className="col" style={{ marginTop: "10%", marginRight: "10%" }}>
          <HamburgerMenu
            menuClicked={this.handleClick.bind(this)}
            isOpen={this.state.open}
            width={24}
            height={15}
            strokeWidth={2}
            rotate={0}
            color={color}
            borderRadius={0}
            animationDuration={0.5}
          />
        </div>
        {this.state.open ? (
          <div
            className={this.state.open ? 'menu-col-active' : 'menu-col'}
            style={{
              backgroundColor: backgroundColor,
              padding: "2% 0% 2% 0%",
              marginTop: "-14%",
              flexBasis: "100%"
            }}
          >
            {/* <a href="/">
            <img
              src={KinderWhite}
              type="image/svg+xml"
              style={{ marginLeft: "30%", width: "175px" }}
            >

            </img> 
          </a> */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                fontSize: 20,
                paddingTop: "20%",
                border:"none"
              }}
            >
              <Link
                to="/"
                style={{
                  color: color,
                  textDecoration: "none"
                }}
              >
                App
              </Link>
              {/* <Link
                to="/corporate"
                style={{
                  color: color,
                  textDecoration: "none"
                }}
              >
                Corporate
              </Link> */}
              <Link
                to="/Team"
                style={{
                  color: color,
                  textDecoration: "none"
                }}
              >
                Team
              </Link>
              <Link
                to="/Contact"
                style={{
                  color: color,
                  textDecoration: "none"
                }}
              >
                Contact
              </Link>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }
}

export default MobileHeader;
